import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
 
@Injectable({
   providedIn: 'root'
})
 
export class MetaService { 
   constructor(@Inject(DOCUMENT) private dom) { }
    
    createCanonicalURL() {
    	let link: HTMLLinkElement = this.dom.createElement('link');
    	link.setAttribute('rel', 'canonical');
    	this.dom.head.appendChild(link);
    	link.setAttribute('href', this.dom.URL);
    }

    updateCanonicalURL(){
    	let links = this.dom.getElementsByTagName("link");
    	let url = this.dom.URL;
    	let urls = url.split("?");
 		links[0].setAttribute('href',urls[0]);
    }

    setCanonicalURL(url = '') {
    	let links = this.dom.getElementsByTagName("link");
    	if(url == ''){
    		url = this.dom.URL;
    	} else {
    		url = location.origin+url;
    	}
    	let urls = url.split("?");
 		links[0].setAttribute('href',urls[0]);
    }

    updateCanonicalURLParam(param) {
        let links = this.dom.getElementsByTagName("link");
        let url = this.dom.URL;
        let urls = url.split("?");
         links[0].setAttribute('href',urls[0]+'?'+param);
    }
} 